import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const LazyDabContainer = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "planner-dab" */ "./DabContainer")).then((bundle)=>({
            default: bundle.DabContainer
        })));
